import type { FeatureBlockContent, HeroContent } from './types';

export const cardsHero: HeroContent = {
  title: 'The card built\nfor the world',
  cta: { label: 'Get the app', href: '/get-the-app' },
  image: {
    src: '/images/cards/hero.jpg',
    webpSrc: '/images/cards/hero.webp',
    alt: 'Hand holding a phone showing the nsave app with a red nsave Visa card on a breakfast table',
  },
};

export const cardsSpend: FeatureBlockContent = {
  title: 'Spend',
  image: {
    src: '/images/cards/spend.jpg',
    webpSrc: '/images/cards/spend.webp',
    alt: 'Person holding a phone displaying the nsave Visa card beside a breakfast bowl and orange juice',
  },
  rows: [
    {
      icon: 'globe',
      title: 'Spend globally in 180+ countries',
      description:
        'Use your nsave Visa card wherever you go. Online and in-store, accepted everywhere.',
    },
    {
      icon: 'percent',
      title: 'No foreign transaction fees',
      description:
        'Pay in local currency with real exchange rates. No hidden markups eating into your money.',
    },
    {
      icon: 'card',
      title: 'Virtual nsave card',
      description: 'Your dreams have no borders. Neither does your card.',
    },
  ],
};

export const cardsPayInATap: FeatureBlockContent = {
  title: 'Pay in a tap',
  image: {
    src: '/images/cards/pay-in-a-tap.jpg',
    webpSrc: '/images/cards/pay-in-a-tap.webp',
    alt: 'Tapping a phone with the nsave card to a contactless reader at a fruit market stall',
  },
  rows: [
    {
      icon: 'phone',
      logo: '/logos/apple.svg',
      title: 'Add to Apple Pay',
      description:
        'Your nsave card lives in your iPhone or Apple Watch. Tap to pay anywhere contactless is accepted.',
    },
    {
      icon: 'wallet',
      logo: '/logos/google.svg',
      title: 'Add to Google Wallet',
      description:
        'Android user? Add your card in seconds and start paying with your phone straight away.',
    },
  ],
};

export const cardsControl: FeatureBlockContent = {
  title: 'Control',
  image: {
    src: '/images/cards/control.jpg',
    webpSrc: '/images/cards/control.webp',
    alt: 'A couple at a café reviewing their card settings together in the nsave app',
  },
  rows: [
    {
      icon: 'snowflake',
      title: 'Freeze & unfreeze instantly',
      description: "One tap to lock your card, one tap to bring it back. You're always in control.",
    },
    {
      icon: 'bell',
      title: 'Real-time spending alerts',
      description:
        "Get notified the moment a transaction hits. Always know what's happening with your money.",
    },
    {
      icon: 'help',
      title: 'Get 24/7 support',
      description: "Reach our team any time, day or night, whether you're at home or abroad.",
    },
  ],
};
